import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NewsModel } from '../../../models/centre/news.models';
import { BaseService } from '../../../shared/services/base.service';
import { NewMemoUrl } from '../../../shared/urls/newmemo.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { Message } from '../../../models/centre/message.model';
import { WorldTravelNewModel } from '../../../models/centre/manage-memo.model';
import * as xml2js from 'xml2js';
import { WorldTravelNews } from '../../../models/centre/news.models';
import { DomSanitizer } from '@angular/platform-browser';
import { SpinnerService } from '../../../components/spinner/spinner.service';

@Injectable()
export class NewsService {
    constructor(
        private http: Http,
        private sanitizer: DomSanitizer,
        public baseService: BaseService,
    public spinnerService: SpinnerService) { }


    getAllMemo(param) {
        const url = NewMemoUrl.GET_ALL_NEW_MEMO;
        return this.baseService.getData(url, param);
    }

    getAllClinicNew(param) {
        const url = NewMemoUrl.GET_CLINIC_MEMO;
        return this.baseService.getData(url, param);
    }
    getAllWorldTravelNew(callback) {
        this.spinnerService.show();
        const url = NewMemoUrl.GET_WORLD_TRAVEL_NEW;
        this.http.get(url).subscribe(res => {
            this.spinnerService.hide();
            if (res) {
                const data = res['_body'];
                xml2js.parseString(data, function (err, result) {
                    const worldTravelNewsList = new Array<WorldTravelNews>();
                    if (result) {
                        if (result.feed) {
                            if (result.feed.entry) {
                                if (result.feed.entry.length > 0) {
                                    const entries = <Array<any>>result.feed.entry;
                                    entries.forEach(element => {
                                        const tempObj = new WorldTravelNews();
                                        tempObj.id = (<string>element.NewsReportId[0]).trim();
                                        tempObj.memo = (<string>element.Details[0]).trim().replace(/\|e2\|\`9/g, '&');
                                        tempObj.publiser = (<string>element.NewsCategoryName[0]).trim() +
                                            ' ' + (<string>element.CountryName[0]).trim();
                                        tempObj.publishDate = new Date((<string>element.ReceivedDate[0]).trim());
                                        tempObj.title = (<string>element.Headline[0]).trim();
                                        worldTravelNewsList.push(tempObj);
                                    });
                                    callback(worldTravelNewsList);
                                }
                            }
                        }
                    }
                    callback(worldTravelNewsList);
                });
            }
        }, error => {
            this.spinnerService.hide();
            callback(null);
        });
    }

}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/news-memo/new.service.ts